//@libs
import PropTypes from "prop-types";

import { FaEdit } from 'react-icons/fa';

//@components
import IconButton from "./";

const EditIconButton = ({ title = "Editar", customIcon = null, ...props }) => {
  return (
    <IconButton
      sx={{
        "&:hover": {
          color: "warning.main",
          transform: "scale(1.1)",
        },
      }}
      title={title}
      icon={customIcon || <FaEdit className="text-blue-600 text-lg hover:scale-110 transition-transform" />}
      {...props}
    />
  );
};

EditIconButton.propTypes = {
  title: PropTypes.string,
};

export default EditIconButton;
